<div
  class="flex flex-row justify-start items-start flex-grow-1 flex-shrink-0 w-1/4"
>
  <div
    class="flex-grow flex-shrink basis-full flex md:flex-row flex-col gap-x-2 justify-start items-center"
    [ngSwitch]="criteriaItem.type"
    [formGroup]="criteriaItem.formControl"
  >
    <ng-container *ngSwitchCase="'fromToDate'">
      <mat-form-field class="from-to-date flex-grow-0 flex-shrink-0 basis-1/2">
        <mat-label>From</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          formControlName="from"
          placeholder="From date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="from-to-date flex-grow-0 flex-shrink-0 basis-1/2">
        <mat-label>To</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          formControlName="to"
          placeholder="To date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="toPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'minMax'">
      <mat-form-field class="from-to-date flex-grow-0 flex-shrink-0 basis-1/2">
        <mat-label>Minimum</mat-label>
        <input matInput formControlName="min" placeholder="Minimum" />
      </mat-form-field>
      <mat-form-field class="from-to-date flex-grow-0 flex-shrink-0 basis-1/2">
        <mat-label>Maximum</mat-label>
        <input matInput formControlName="max" placeholder="Maximum" />
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'dropDown'">
      <mat-form-field class="flex-grow-0 flex-shrink-0 basis-full">
        <mat-label>{{ criteriaItem.name }}</mat-label>
        <mat-select formControlName="value">
          <mat-option
            *ngFor="let option of criteriaItem.options"
            [value]="option.id"
            >{{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
  <button
    class="flex-shrink-0 flex-grow-0 mt-2"
    (click)="removeCriterion()"
    type="button"
    mat-icon-button
    matTooltip="Remove {{ criteriaItem.name }}"
    matTooltip-position="left"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
